import React from "react";
import { useQuery } from "@tanstack/react-query";
import { auth } from "../../components/Auth/Auth";
import { signOut } from "firebase/auth";
import { jwtDecode } from "jwt-decode";

const GetDashBoardDataAPI = async () => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  const token = await user.getIdToken();

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/dashboard/dashboardInfo`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  if (!response.ok) {
    if (response.status === 401) {
      // End the Firebase session when the backend rejects authentication.
      await signOut(auth);

      throw new Error("Unauthorized: Please log in again.");
    }
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const useDashBoardData = () => {
  const { data, isPending, error } = useQuery({
    queryKey: ["dashboardData"],
    queryFn: GetDashBoardDataAPI,
    retry: false,
  });

  return { data, isPending, error };
};
